import { Component } from '@angular/core';

@Component({
  selector: 'homas-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'homas';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts